import { render, staticRenderFns } from "./Group-Restore.vue?vue&type=template&id=2cfa197e&scoped=true&"
import script from "./Group-Restore.vue?vue&type=script&lang=js&"
export * from "./Group-Restore.vue?vue&type=script&lang=js&"
import style0 from "./Group-Restore.vue?vue&type=style&index=0&id=2cfa197e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfa197e",
  null
  
)

export default component.exports